module.exports = __webpack_public_path__ + "img/account-icon.d8148ef1.svg";